import { makeStyles } from "@material-ui/core";
import React from "react";
import LoadingIndicator from "../LoadingIndicator";
const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        minHeight: "100%",
        padding: theme.spacing(3),
    },
}));
function LoadingScreen({ variant }) {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(LoadingIndicator, { variant: variant })));
}
LoadingScreen.defaultProps = {
    variant: "circular",
};
export default LoadingScreen;
//# sourceMappingURL=index.js.map